import {
    IPartialTheme,
    IStyleFunctionOrObject,
    IStyleSet
} from "@fluentui/react"

import { IAdditionalValueStyles } from "./AdditionalValue.types"

export const AdditionalValueStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IAdditionalValueStyles>
> = (theme) => ({
    modal: {},
    overlay: {},
    dialog: {},
    layer: {},
    text: { display: "block", marginTop: 0, paddingBottom: 28 },
    textField: {
        ".ms-TextField-fieldGroup": {
            borderColor: theme.palette?.neutralTertiary
        },
        ".ms-TextField-fieldGroup:hover": {
            borderColor: theme.palette?.neutralSecondary
        },
        "input::placeholder": {
            fontStyle: "italic",
            color: theme.palette?.neutralSecondary
        }
    },
    dialogFooter: {},
    applyButton: {
        border: "none",
        borderRadius: "0",
        ":focus&::after": {
            outlineOffset: "3",
            outlineColor: theme.semanticColors?.focusBorder
        },
        ":hover": {
            border: "none"
        },
        ":active": {
            border: "none"
        }
    },
    dismissButton: {
        border: "none",
        borderRadius: "0",
        marginLeft: ".5em",
        ":focus&::after": {
            outlineOffset: "3",
            outlineColor: theme.semanticColors?.focusBorder
        }
    }
})
